import {
    apiRequest,
    employeeStatusDetail
} from "../../../../../services/adapters/master/employeeStatusService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeStatusDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository